
export const MembershipBenefitType = {
    FreeItem: "free_item"
}